import { render, staticRenderFns } from "./editDistribution.vue?vue&type=template&id=41e575f2&scoped=true&"
import script from "./editDistribution.vue?vue&type=script&lang=js&"
export * from "./editDistribution.vue?vue&type=script&lang=js&"
import style0 from "./editDistribution.vue?vue&type=style&index=0&id=41e575f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e575f2",
  null
  
)

export default component.exports